module.exports = __webpack_public_path__ + "img/alterapay.7bb1d297.gif";